import { Modal } from 'antd';
import React, { type FC } from 'react';

import type { Feedback } from '@/types/database/feedback';

import ModalBody from './ModalBody';

const MessageModal: FC<{
  feedback: Feedback | null;
  open: boolean;
  onClose: () => void;
}> = ({ feedback, open, onClose }) => {
  return (
    <Modal
      open={open}
      title={feedback?.title}
      footer={false}
      onCancel={onClose}
      centered
      width={800}
      destroyOnClose
    >
      {feedback && <ModalBody feedback={feedback} />}
    </Modal>
  );
};

export default MessageModal;
